import { useState, useEffect } from 'react'
import { useIdleTimer } from 'react-idle-timer/legacy'
import { Typography, Box, Button } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router'
import useUserManager from 'packages/core/auth/useUserManager'
import Modal from '../Modal'
import { getSubdomain, getCookies, setCookies } from '../Helper'

const IdleTimer = ({ loginSessionTimeout, allowedUrls }) => {
    const [open, setOpen] = useState(false)
    const [clicked, setClicked] = useState(false)
    const { t } = useTranslation()
    const history = useHistory()
    const userManager = useUserManager()
    const [user, setUser] = useState(null)
    const allowedApps = []
    const [sessionActive, setSessionActive] = useState(true)
    const currentApp = getSubdomain(window.location.hostname)

    allowedUrls.forEach((allowedUrl) => {
        const url = allowedUrl.applicationAbsoluteUrl
        const subdomain = getSubdomain(url)
        allowedApps.push(subdomain)
    })

    const No_Button = {
        border: '1px #2F7FC1 solid',
        borderRadius: '5px',
    }

    const Yes_Button = {
        bgcolor: '#2F7FC1',
        border: '1px #2F7FC1 solid',
        color: 'white',
        borderRadius: '5px',
        marginLeft: '15px',
    }

    const handleClose = () => {
        setClicked(true)
        setOpen(false)
    }

    const onActive = () => {
        setCookies(`${user?.profile.oid}_sessionActive_${currentApp}`, true)
        setSessionActive(true)
    }

    const onIdle = () => {
        setCookies(`${user?.profile.oid}_sessionActive_${currentApp}`, false)
        setSessionActive(false)

        for (const App of allowedApps) {
            if (
                App !== currentApp &&
                getCookies(`${user?.profile.oid}_sessionActive_${App}`)
            ) {
                activate()
                setSessionActive(true)
                break
            }
        }
        setClicked(false)
        setOpen(true)
    }

    const footerContent = (
        <Box>
            <Button
                sx={No_Button}
                onClick={() => {
                    history.push('/signout')
                    setClicked(true)
                    setOpen(false)
                }}
            >
                {t('No')}
            </Button>

            <Button variant="contained" sx={Yes_Button} onClick={handleClose}>
                {t('Yes')}
            </Button>
        </Box>
    )

    const headerContent = <Typography>{t('Login_Session_Timeout')}</Typography>

    const { activate } = useIdleTimer({
        onIdle,
        onActive,
        timeout: loginSessionTimeout,
        throttle: 500,
    })

    useEffect(() => {
        const fetchUserData = async () => {
            try {
                const userData = await userManager.getUser()
                setUser(userData)
            } catch (error) {
                console.error('Error fetching user data:', error)
            }
        }
        fetchUserData()

        let timeoutId
        if (!sessionActive && !clicked && open) {
            timeoutId = setTimeout(() => {
                history.push('/signout')
            }, 300000)
        }
        return () => {
            clearTimeout(timeoutId)
        }
    }, [clicked, open, sessionActive, userManager])

    return (
        <div>
            <Modal
                headerContent={headerContent}
                open={open}
                onClose={handleClose}
                title={t('Login_Session_Timeout')}
                footerContent={footerContent}
                customDialogClass={{
                    '.MuiPaper-elevation': {
                        '& > #dialog-header': {
                            padding: '18px 20px !important',
                            alignItems: 'center',
                        },
                        '& > #dialog-body': {
                            padding: '20px 20px !important',
                        },
                        '& > #dialog-footer': {
                            padding: '15px 20px !important',
                        },
                    },
                }}
            >
                <Typography>{t('LoginSessionTimeoutMessage')}</Typography>
            </Modal>
        </div>
    )
}

export default IdleTimer
